import { CheckoutVoucherInterface } from '../checkout.service';

export class CheckoutItemModel {
  private _price: number = 1;

  public spiritual: string = '';
  public voucher: CheckoutVoucherInterface;
  public availableDesigns: string[] = [
    'aurora',
    'blumenwiese',
    'edelstein',
    'feuer',
    'filigran',
    'galaxy',
    'gold',
    'kompass',
    'mondlicht',
    'phantasy',
    'urwald',
    'wolken'
  ];
  private startDesign: string = this.shuffleArray(this.availableDesigns)[0];
  public design: string = this.startDesign;
  public isGift: boolean = false;
  public gift: {
    firstName: string,
    lastName: string,
    email: string,
    emailConfirm: string,
    greetingsMessage: string,
    giverFirstName: string,
    giverLastName: string
  } = {
    firstName: null,
    lastName: null,
    email: null,
    emailConfirm: null,
    greetingsMessage: null,
    giverFirstName: null,
    giverLastName: null
  };

  public get price(): number {
    return this._price;
  }

  public set price(value: number) {
    value = value * 1;

    // this._price = value > 1000 ? 1000 : value;
    this._price = value;
  }

  public getForcedDesignValues(): string[] {
    if (this.voucher) {
      return [this.voucher.isGift ? this.voucher.button.design : 'weissgold'];
    } else {
      return this.availableDesigns;
    }
  }

  public isTouched() {
    return this.voucher ||
      this._price !== 1 ||
      this.spiritual !== '' ||
      this.design !== this.startDesign;
  }

  public toJSON() {
    return {
      price: this._price,
      design: this.design,
      spiritual: this.spiritual,
      isGift: this.isGift,
      gift: this.gift,
      voucher: this.voucher
    };
  }
  
  private shuffleArray(arr: Array<any>) {
    var j, x, i;
    
    for (i = arr.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = arr[i];
      arr[i] = arr[j];
      arr[j] = x;
    }
    
    return arr;
  }
}


// WEBPACK FOOTER //
// ./src/app/checkout/models/item.model.ts